import "../css/style.scss";
import { Fancybox } from "@fancyapps/ui";
import { scroll, smooth } from "./Module/loco";
import { select } from "./Module/Helper";
import { accordionInit } from "./Module/components/accordian";
import { createtestSlider } from "./Module/sliders/projectSlider";
import { createLazyLoad } from "./Module/lazyLoad"


smooth();
createLazyLoad();

setTimeout(() => { scroll.update() }, 900)

const accordion = document.querySelector(".accordion");
if (accordion) accordionInit(accordion);


    
// const testel = select("#test .swiper");

// createtestSlider(testel);

const sucel = select("#success .swiper");
createtestSlider(sucel);




const menuClose = () => { document.getElementById("trigger").checked = false }

const pagelinks = document.querySelectorAll(".mob-menu a[href]");
pagelinks.forEach(link => link.addEventListener("click", menuClose));
